/**
* *************************************************************************
*  ADOBE CONFIDENTIAL
*  ___________________
* 
*   Copyright 2017 Adobe
*   All Rights Reserved.
* 
*  NOTICE:  All information contained herein is, and remains
*  the property of Adobe and its suppliers, if any. The intellectual
*  and technical concepts contained herein are proprietary to Adobe
*  and its suppliers and are protected by all applicable intellectual
*  property laws, including trade secret and copyright laws.
*  Dissemination of this information or reproduction of this material
*  is strictly forbidden unless prior written permission is obtained
*  from Adobe.
* **************************************************************************
* 
**/'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.I18nContext = exports.I18nConsumer = exports.default = undefined;
var _jsxFileName = '/Users/kbhavani/ExC/LearnReact/exc-sdk/src/localization/i18n.js';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _intlRelativeformat = require('intl-relativeformat');

var _intlRelativeformat2 = _interopRequireDefault(_intlRelativeformat);

var _FormattedDateTime = require('./formatters/FormattedDateTime');

var _FormattedDateTime2 = _interopRequireDefault(_FormattedDateTime);

var _FormattedRelative = require('./formatters/FormattedRelative');

var _FormattedRelative2 = _interopRequireDefault(_FormattedRelative);

var _FormattedNumber = require('./formatters/FormattedNumber');

var _FormattedNumber2 = _interopRequireDefault(_FormattedNumber);

var _FormattedMessage = require('./formatters/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedHTMLMessage = require('./formatters/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _FormatMessageInterpolator = require('./interpolator/FormatMessageInterpolator');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var supportedLocales = ['de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'zh'];
var defineGlobalIntl = function defineGlobalIntl() {
  if (typeof window !== 'undefined') {
    window.IntlRelativeFormat = _intlRelativeformat2.default;
  } else if (typeof global !== 'undefined') {
    global.IntlRelativeFormat = _intlRelativeformat2.default;
  }

  supportedLocales.forEach(function (lang) {
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('intl-relativeformat/dist/locale-data/' + lang));
    });
  });
};

var I18nContext = _react2.default.createContext();

/**
 * I18n Provider
 */

var I18nProvider = function (_Component) {
  _inherits(I18nProvider, _Component);

  function I18nProvider(props) {
    _classCallCheck(this, I18nProvider);

    var _this = _possibleConstructorReturn(this, (I18nProvider.__proto__ || Object.getPrototypeOf(I18nProvider)).call(this, props));

    var _this$props = _this.props,
        locale = _this$props.locale,
        localeData = _this$props.localeData;
    var _this$props2 = _this.props,
        autoLocale = _this$props2.autoLocale,
        interpolator = _this$props2.interpolator;


    if (autoLocale === true) {
      locale = _this.getUserLanguage();
    }

    defineGlobalIntl();
    _this.getMessage = _this.getMessage.bind(_this);
    _this.getUpdatedLocaleData = _this.getUpdatedLocaleData.bind(_this);
    _this.getLocaleDataWithLanguageCode = _this.getLocaleDataWithLanguageCode.bind(_this);
    localeData = _this.getUpdatedLocaleData(localeData);

    _this.state = {
      locale: locale,
      localeData: localeData,
      interpolator: interpolator
    };
    return _this;
  }

  _createClass(I18nProvider, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          locale = _props.locale,
          localeData = _props.localeData,
          interpolator = _props.interpolator;
      var autoLocale = this.props.autoLocale;

      var currentLocaleData = prevState.localeData;

      if (autoLocale === true) {
        locale = this.getUserLanguage();
      }
      if (localeData && localeData !== prevProps.localeData) {
        currentLocaleData = this.getUpdatedLocaleData(localeData);
      }
      if (locale !== prevState.locale || currentLocaleData !== prevState.localeData || interpolator !== prevState.interpolator) {
        this.setState({
          locale: locale,
          localeData: currentLocaleData,
          interpolator: interpolator
        });
      }
    }

    /**
     * Method to replace the '_' in locale with '-'
     * @param {object} localeData the original localeData with '_' in locales
     * @returns {object} The updated localeData with '-' in locales
     */

  }, {
    key: 'getUpdatedLocaleData',
    value: function getUpdatedLocaleData(localeData) {
      var updatedLocaleData = {};

      Object.keys(localeData).map(function (local) {
        var localeKey = local.replace(/_/g, '-');

        updatedLocaleData[localeKey] = localeData[local];
      });

      return updatedLocaleData;
    }

    /**
     * Method to retrieve the locale data given the supported locale instead of full locale
     * @param {string} supportedLocale Input supported locale
     * @returns {object} The messages corresponding to the supportedLocale
     */

  }, {
    key: 'getLocaleDataWithLanguageCode',
    value: function getLocaleDataWithLanguageCode(supportedLocale) {
      var localeData = this.state.localeData;

      var messages = void 0;

      Object.keys(localeData).map(function (local) {
        if (local.startsWith(supportedLocale)) {
          messages = localeData[local];
        }
      });

      return messages;
    }

    /**
     * Method to retrieve the templated string from the localeData
     * @param {string} messageId The message id to retrieve the templated string
     * @returns {string} The templated string if found otherwise and empty string
     */

  }, {
    key: 'getMessage',
    value: function getMessage(messageId) {
      var _state = this.state,
          locale = _state.locale,
          localeData = _state.localeData;

      var messages = void 0;

      if (_typeof(localeData[locale]) === 'object') {
        messages = localeData[locale];
      } else if (supportedLocales.includes(locale)) {
        messages = this.getLocaleDataWithLanguageCode(locale);
      }

      if (messages && messages[messageId]) {
        return messages[messageId];
      }

      return null;
    }

    /**
     * Method to get the user navigator language locale
     * @returns {string} the string locale
     */

  }, {
    key: 'getUserLanguage',
    value: function getUserLanguage() {
      return window.navigator.userLanguage || window.navigator.language;
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var interpolator = this.state.interpolator;


      return _react2.default.createElement(
        I18nContext.Provider,
        {
          value: {
            interpolator: interpolator,
            getUserLanguage: this.getUserLanguage,
            getMessage: this.getMessage,
            FormattedDateTime: _FormattedDateTime2.default.bind(null, this),
            FormattedRelative: _FormattedRelative2.default.bind(null, this),
            FormattedNumber: _FormattedNumber2.default.bind(null, this),
            FormattedMessage: _FormattedMessage2.default.bind(null, this),
            FormattedHTMLMessage: _FormattedHTMLMessage2.default.bind(null, this)
          },
          __source: {
            fileName: _jsxFileName,
            lineNumber: 166
          },
          __self: this
        },
        children
      );
    }
  }]);

  return I18nProvider;
}(_react.Component);

I18nProvider.defaultProps = {
  locale: 'en-US',
  localeData: {},
  autoLocale: false,
  interpolator: _FormatMessageInterpolator.formatMessageInterpolator
};
I18nProvider.propTypes = {
  /** User language locale string */
  locale: _propTypes2.default.string,
  /** Language strings data */
  localeData: _propTypes2.default.objectOf(_propTypes2.default.shape({})),
  /** Automatically switch the locale based on the user browser preferences */
  autoLocale: _propTypes2.default.bool,
  /** interpolator function to parse string messages */
  interpolator: _propTypes2.default.func
};


var I18nConsumer = I18nContext.Consumer;

exports.default = I18nProvider;
exports.I18nConsumer = I18nConsumer;
exports.I18nContext = I18nContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@exc-ui/exc-sdk/dist/production/localization/i18n.js
// module id = 93
// module chunks = 0